import React from 'react';
import { Hero } from '../components/home/Hero';
import { Problem } from '../components/home/Problem';
import { WhatToBuild } from '../components/home/WhatToBuild';
import { OriginSystem } from '../components/home/OriginSystem';
import { DemoSection } from '../components/home/DemoSection';
import { Applications } from '../components/home/Applications';
import { ResultSection } from '../components/home/ResultSection';
import { AutomationTiers } from '../components/home/AutomationTiers';
import { PricingDetail } from '../components/home/PricingDetail';
import { Voice } from '../components/home/Voice';
import { VoicePlans } from '../components/home/VoicePlans';
import { HowWeBuild } from '../components/home/HowWeBuild';
import { IncludesSection } from '../components/home/IncludesSection';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-368" data-mp="3owvl5wtqc60g">
      <Hero data-id="element-369" data-mp="3ow421lhbk0r2" />
      <Problem data-id="element-370" data-mp="3ovkk44ro5cd1" />
      <WhatToBuild data-id="element-371" data-mp="3ovauwjeg798e" />
      <OriginSystem data-id="element-372" data-mp="3oyq9zm84gi9t" />
      <DemoSection data-id="element-373" data-mp="30wjaok4gik28" />
      <Applications data-id="element-374" data-mp="30x1i8cwkkkpg" />
      <ResultSection data-id="element-375" data-mp="30vgjsc74whmb" />
      <AutomationTiers data-id="element-376" data-mp="30up121ymyedg" />
      <PricingDetail data-id="element-377" data-mp="2vxot1li871jp" />
      <Voice data-id="element-378" data-mp="2vxf31xx6kue0" />
      <VoicePlans data-id="element-379" data-mp="2vyq4vs72fs2h" />
      <HowWeBuild data-id="element-380" data-mp="2vyhty5ui6wtx" />
      <IncludesSection data-id="element-381" data-mp="2vvvms7biyjc8" />
      <FinalCTA data-id="element-382" data-mp="2qybysfp0ys73" />
    </div>;
}